document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-dps-open-details]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target || target.tagName !== 'DETAILS') return;
  event.preventDefault();
  if (!target.open) target.querySelector('summary')?.click();
  target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
  target.querySelector('summary')?.focus({preventScroll:true});
});
document.addEventListener('error', (event) => {
  const img = event.target;
  if (img.tagName === 'IMG' && img.closest('.jdgm-widget') && !img.classList.contains('jdgm-star')) img.hidden = true;
}, true);

const hideFailedReviewImages = () => document.querySelectorAll('.jdgm-widget img').forEach((img) => { if (img.complete && img.naturalWidth === 0 && (img.currentSrc || img.src)) img.hidden = true; });
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideFailedReviewImages, { once: true }); else hideFailedReviewImages();
